import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, custom }: Theme) => ({
  travelSymbolContainer: {
    [breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  travelSymbol: {
    marginBottom: -170,
    marginLeft: 30,
    position: 'relative',
    zIndex: 3,
    [breakpoints.down(1000)]: {
      marginBottom: -110,
      width: 250,
    },
  },
}));
